import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/configuration',
    name: 'configuration',
    component: () => import('../views/configuration/IndexView.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/configuration/appearance',
    name: 'configuration-appearance',
    component: () => import('../views/configuration/AppeareanceView.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/configuration/integrations',
    name: 'configuration-integrations',
    component: () => import('../views/configuration/IntegrationsView.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/configuration/providers',
    name: 'configuration-providers',
    component: () => import('../views/configuration/ProvidersView.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/configuration/app',
    name: 'configuration-app',
    component: () => import('../views/configuration/App.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/configuration/commission',
    name: 'configuration-commission',
    component: () => import('../views/configuration/CommissionView.vue'),
    meta: { layout: appLayout }
  },
]
